import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../theme/theme';

interface ProgressTrackProps {
  stages: string[];
  activeIndex: number;
}

/** Filled pink line + checkpoint dots — the studio-facing replacement for a stock MUI Stepper. */
const ProgressTrack: React.FC<ProgressTrackProps> = ({ stages, activeIndex }) => {
  const segments = stages.length - 1;
  const filledPct = segments > 0 ? (activeIndex / segments) * 100 : 0;

  return (
    <Box sx={{ position: 'relative', px: 0.75 }}>
      <Box sx={{ position: 'absolute', top: 9, left: 26, right: 26, height: 4, backgroundColor: '#ececf0', borderRadius: '2px' }} />
      <Box
        sx={{
          position: 'absolute', top: 9, left: 26, height: 4, backgroundColor: colors.primary, borderRadius: '2px',
          width: `calc((100% - 52px) * ${filledPct / 100})`,
        }}
      />
      <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'space-between' }}>
        {stages.map((label, i) => {
          const done = i < activeIndex;
          const current = i === activeIndex;
          return (
            <Box key={label} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: current ? 1 : 1.1, width: 90 }}>
              {done ? (
                <Box sx={{ width: 20, height: 20, borderRadius: '50%', backgroundColor: colors.primary, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                </Box>
              ) : current ? (
                <Box sx={{ width: 22, height: 22, borderRadius: '50%', backgroundColor: '#ffffff', border: `3px solid ${colors.primary}`, boxShadow: `0 0 0 4px ${colors.primary}29` }} />
              ) : (
                <Box sx={{ width: 20, height: 20, borderRadius: '50%', backgroundColor: '#ffffff', border: '2px solid #dcdce2' }} />
              )}
              <Typography sx={{ fontSize: 12, fontWeight: current ? 700 : 600, color: current ? colors.primary : done ? '#4a4a54' : '#b5b5c0', textAlign: 'center' }}>
                {label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default ProgressTrack;
